import { useCallback } from 'react';

export const useOwnerProps = <P, A extends object = Record<string, never>>(props: P, args?: A) => {
  const getOwnerProps = useCallback(() => props, [props]);
  const getOwnerPropsArguments = useCallback(() => args ?? {}, [args]);
  return { getOwnerProps, getOwnerPropsArguments };
};
